import React from 'react';
import './App.css';
import './fonts/Gotham/font.css';
import FormContainer from './Container/FormContainer';
import { evtTrack } from './utils/analytics';
import { isMobileOnly } from 'react-device-detect';
import WheelContainer from './Container/WheelContainer';
import ScrollButtonContainer from './Container/ScrollButtonContainer';

function App() {

  evtTrack('25daysofchristmas2020-sweeps-intro-page');
  const appClassName="App" + (isMobileOnly?" mobile":"");

  return (
    <div className={appClassName}>
      <header>
        <h1 className="gotham-ultra">
            Game Show Network - 
          25 Days of Christmas Giveaway
        </h1>
      </header>
      <WheelContainer />
      <ScrollButtonContainer />
      <FormContainer />
      <div className="footer-banner">
        <a href="https://www.amazon.com/Game-Show-Network-Common-Knowledge/dp/B07ZDJ38JG/ref=sr_1_1?keywords=alexa+skill+common+knowledge&qid=1572372876&sr=8-1" target="_blank">
          <img src="images/CK_Alexa_25DaysOfXmas_728x90_V2_NOGSNLOGO.jpg" alt="Play Common Knowledge on Alexa" />
        </a>
      </div>
      <footer>
        <div className="abv-legal">
          <p>
          NO PURCHASE NECESSARY TO ENTER OR WIN.  A PURCHASE WILL NOT IMPROVE YOUR CHANCES OF WINNING.  Promotion consists of an Instant Win Game and a Sweepstakes and begins on or about December 1, 2020 at 12:00:01 a.m. Pacific Time (“PT”) and ends on December 25, 2020 at 11:59:59 p.m. PT.  Must be 18 or older. See Official Rules at <a href="/25daysofchristmas/rules" target="_top">https://www.gameshownetwork.com/25daysofchristmas/rules</a> for complete information, including how to enter and play, eligibility restrictions, prize descriptions/restrictions/ARVs and complete details.  Void where prohibited.  Sponsored by Game Show Network, LLC, 2150 Colorado Avenue, Suite 100, Santa Monica, California. 
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
